import React, { useState } from 'react';

import { useForm } from 'react-hook-form';

import { CircularProgress } from '@mui/material';

import { Form } from 'components/ui/form';

import { useStoreSettingsInitialValues } from '../../hooks/useStoreSettingsInitialValues';
import { EQuantityFormatKey, IStoreSettingsFormValues } from '../../StoreSettings.types';

import { ABBREVIATIONS_V2_TEST_IDS } from './AbbreviationsSettingsV2.consts';
import { abbreviationsFormResolver } from './AbbreviationsSettingsV2.validation';
import { AbbreviationsErrorState } from './components/AbbreviationsErrorState';
import { AbbreviationsHeader } from './components/AbbreviationsHeader';
import { OfferTypeTabs } from './components/OfferTypeTabs';
import { QuantityFormatPanel } from './components/QuantityFormatPanel';
import { useAbbreviationsAutosave } from './hooks/useAbbreviationsAutosave';

export const AbbreviationsSettingsV2 = (): React.ReactElement => {
  const { initialValues, getGeneralTheme } = useStoreSettingsInitialValues();
  const [activeTab, setActiveTab] = useState<EQuantityFormatKey>(
    EQuantityFormatKey.PRODUCTS
  );

  const form = useForm<IStoreSettingsFormValues>({
    resolver: abbreviationsFormResolver,
    mode: 'onChange',
    values: initialValues
  });

  const { commitField } = useAbbreviationsAutosave({ form });

  if (getGeneralTheme.isLoading) {
    return (
      <div className="flex w-full justify-center p-9">
        <CircularProgress />
      </div>
    );
  }

  if (getGeneralTheme.isError) {
    return <AbbreviationsErrorState onRetry={(): void => void getGeneralTheme.refetch()} />;
  }

  return (
    <Form {...form}>
      <div
        className="flex w-full flex-col gap-9 rounded-lg border border-base-border bg-white p-9"
        data-testid={ABBREVIATIONS_V2_TEST_IDS.root}
      >
        <div className="flex flex-col gap-9">
          <AbbreviationsHeader />
          <div className="flex flex-col gap-5">
            <OfferTypeTabs activeTab={activeTab} onTabChange={setActiveTab} />
            <div className="h-px w-full bg-base-border" />
          </div>
        </div>
        <QuantityFormatPanel
          key={activeTab}
          sectionKey={activeTab}
          onCommit={commitField}
        />
      </div>
    </Form>
  );
};
